export const UPDATE_NEGOCE_FORM = 'UPDATE_NEGOCE_FORM';
export const GET_DATA_FILTERS = 'GET_DATA_FILTERS';
export const GET_DATA_SUBMISSIONS = 'GET_DATA_SUBMISSIONS';
export const GET_DATA_SYNTHESIS_KPI = 'GET_DATA_SYNTHESIS_KPI';
export const GET_DATA_SYNTHESIS_SALES_BY_COUNTRY =
  'GET_DATA_SYNTHESIS_SALES_BY_COUNTRY';
export const GET_DATA_SYNTHESIS_SALES_BY_WINE =
  'GET_DATA_SYNTHESIS_SALES_BY_WINE';
export const GET_DATA_PILOTAGEINTERNE_TOP_NEGOCIANTS =
  'GET_DATA_PILOTAGEINTERNE_TOP_NEGOCIANTS';
export const GET_DATA_PILOTAGEINTERNE_TOP_CUSTOMERS =
  'GET_DATA_PILOTAGEINTERNE_TOP_CUSTOMERS';
export const GET_DATA_PRESENTION_KPIS = 'GET_DATA_PRESENTION_KPIS';
export const GET_DATA_RAW = 'GET_DATA_RAW';
